var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderTiva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 272,
    viewBox: "0 0 272 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "placeholder-background",
    d: "M136 0C60.887 0 0 60.887 0 136C0 211.113 60.887 272 136 272C211.113 272 272 211.113 272 136C272 60.887 211.113 0 136 0Z",
    fill: "#D5DBE7",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5297 163.414C62.5297 168.837 58.1113 173.255 52.6887 173.255C47.2661 173.255 42.8477 168.837 42.8477 163.414V124.084C42.8477 118.661 47.2661 114.243 52.6887 114.243C58.1113 114.243 62.5297 118.661 62.5297 124.084V163.414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 178.945C103.902 184.368 99.4836 188.786 94.061 188.786C88.6384 188.786 84.22 184.368 84.22 178.945V107.548C84.22 102.125 88.6384 97.7069 94.061 97.7069C99.4836 97.7069 103.902 102.125 103.902 107.548V178.945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.751 178.945C187.751 184.368 183.333 188.786 177.91 188.786C172.488 188.786 168.069 184.368 168.069 178.945V107.548C168.069 102.125 172.488 97.7069 177.91 97.7069C183.333 97.7069 187.751 102.125 187.751 107.548V178.945Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.944 80.1003H145.308V202.745C145.308 208.167 140.889 212.586 135.467 212.586C130.044 212.586 125.626 208.167 125.626 202.745V80.1003H76.9899C71.2661 80.1003 66.6468 75.481 66.6468 69.7572C66.6468 64.0333 71.2661 59.4141 76.9899 59.4141H193.944C199.668 59.4141 204.287 64.0333 204.287 69.7572C204.287 75.481 199.668 80.1003 193.944 80.1003Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.157 163.414C229.157 168.837 224.739 173.255 219.316 173.255C213.894 173.255 209.475 168.837 209.475 163.414V124.084C209.475 118.661 213.86 114.243 219.316 114.243C224.772 114.243 229.157 118.661 229.157 124.084V163.414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderTiva);
export default __webpack_public_path__ + "static/media/placeholder-tiva.59b648ac532ce4d46c6bae2672db8fa4.svg";
export { ForwardRef as ReactComponent };